import { Menu, MenuItem, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

export const MenuContainer = styled(Menu)`
  margin-top: 3.25rem;
  border-radius: 10px;
  &::before,
  &::after {
    border: 10px solid transparent;
    border-bottom-color: #ffffff;
  }
  .MuiMenu-paper {
    min-width: 190px;
    background: transparent;
  }
`;

export const ImageContainer = styled.div``;

export const Image = styled.img``;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  gap: 1rem;

  padding: 0.25rem;
`;

export const MenuItemStyled = styled(MenuItem)`
  background-color: #0370b2;
  padding: 0 0.5rem;

  &:active {
    background: #0370b2;
  }
`;

export const LinkStyled = styled(Link)`
  text-decoration: none;
  color: #ffffff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 0.5rem;
  gap: 1rem;

  &:hover {
    background-color: #024e7c !important;
    border-radius: 0.75rem;
  }
`;

export const ButtonStyled = styled(Button)`
  color: #ffffff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-transform: none;
  width: 100%;
  padding: 0.5rem;

  &:hover {
    background-color: #024e7c !important;
    border-radius: 0.75rem;
  }
`;
